import React from "react";
import { useTranslation } from "react-i18next";

import { Tabs, Card, Space, Typography } from "antd";
import type { TabsProps } from "antd";
import { CarOutlined } from "@ant-design/icons";

import { OrderTab } from "./OrderTab";
import { useAntdTheme } from "../../shared/hooks";

const { Title, Text } = Typography;

type ShippingManagerProps = {
  restaurantId: string;
};

export const ShippingManager = (props: ShippingManagerProps) => {
  const { t } = useTranslation();
  const { token } = useAntdTheme();

  const tabItems: TabsProps["items"] = [
    {
      key: "pending",
      label: t("pending"),
      children: (
        <div style={{ marginTop: token.marginMD }}>
          <OrderTab state="pending" restaurantId={props.restaurantId} />
        </div>
      ),
    },
    {
      key: "started",
      label: t("started"),
      children: (
        <div style={{ marginTop: token.marginMD }}>
          <OrderTab state="started" restaurantId={props.restaurantId} />
        </div>
      ),
    },
    {
      key: "done",
      label: t("done"),
      children: (
        <div style={{ marginTop: token.marginMD }}>
          <OrderTab state="done" restaurantId={props.restaurantId} />
        </div>
      ),
    },
  ];

  return (
    <Card
      title={
        <Space>
          <CarOutlined style={{ fontSize: 20, color: token.colorPrimary }} />
          <Text strong style={{ fontSize: token.fontSizeLG }}>
            {t("shipping_orders_management")}
          </Text>
        </Space>
      }
      style={{
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
        border: `1px solid ${token.colorBorder}`,
      }}
      styles={{ body: { padding: token.paddingLG } }}
    >
      <Tabs defaultActiveKey="pending" size="large" items={tabItems} />
    </Card>
  );
};
